import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { ClientPortalWebNarrativeModel, ICPLWebNarrativesClient } from "./api/cplapi/CPLAPI";

export interface IWebNarrativesService {
  getWebNarratives(): Promise<ClientPortalWebNarrativeModel[]>;
  updateWebNarrative(webNarrativeModel: ClientPortalWebNarrativeModel): Promise<void>;
}

@injectable()
export class WebNarrativesService implements IWebNarrativesService {
  @inject(SERVICE_TYPES.CPLWebNarrativesClient) cplWebNarrativesClient!: ICPLWebNarrativesClient;

  getWebNarratives(): Promise<ClientPortalWebNarrativeModel[]> {
    return this.cplWebNarrativesClient.getWebNarratives();
  }

  updateWebNarrative(webNarrativeModel: ClientPortalWebNarrativeModel): Promise<void> {
    return this.cplWebNarrativesClient.updateWebNarrative(webNarrativeModel);
  }
}
